import { Controller } from "@hotwired/stimulus"
import { examples } from "../coreui_examples/configurations"

// The owner stays outside DOM that its component may replace or move.
export default class CoreuiController extends Controller {
  static targets = ["host"]
  static values = { config: Object, state: Object, example: String }

  get host() {
    return this.hasHostTarget ? this.hostTarget : this.element
  }
  options() {
    return { ...examples[this.exampleValue]?.(), ...this.configValue }
  }

  connect() {
    this.mount()
  }

  mount() {
    if (this.instance && !this.instance.signal.aborted) return
    this.instance = new this.constructor.Component(this.host, { ...this.options(), ...this.stateValue.config })
    this.instance.restoreState(this.stateValue)
  }

  configValueChanged(value, previous) {
    if (!this.instance || JSON.stringify(value) === JSON.stringify(previous)) return
    const state = this.instance.snapshotState()
    this.instance.dispose()
    this.instance = new this.constructor.Component(this.host, { ...this.options(), ...state.config, ...value })
    if (!["value", "date", "time", "startDate", "endDate", "options"].some((key) => key in value))
      this.instance.restoreState(state)
  }

  prepareForCache() {
    if (!this.instance || this.instance.signal.aborted) return
    this.stateValue = this.instance.prepareForCache()
    this.instance = null
  }

  disconnect() {
    if (this.instance && this.constructor.Component.getInstance(this.host) === this.instance) {
      this.stateValue = this.instance.snapshotState()
      this.instance.dispose()
    }
    this.instance = null
  }

  show(event) {
    this.instance?.show(event?.currentTarget)
  }
  hide() {
    this.instance?.hide()
  }
  toggle(event) {
    this.instance?.toggle(event?.currentTarget)
  }
  close() {
    this.instance?.close()
  }
  start() {
    this.instance?.start()
  }
  clear() {
    this.instance?.clear()
    this.instance?.inputs?.[0]?.focus()
  }
  next() {
    this.instance?.next()
  }
  prev() {
    this.instance?.prev()
  }
  to(event) {
    this.instance?.to(Number(event.params.index))
  }
}
